import i18next from 'i18next';

/** Parse AI generation errors into user-friendly dialog messages. */
export function describeAiError(err: unknown): string {
  const raw = err instanceof Error ? err.message : String(err);
  const lower = raw.toLowerCase();
  if (lower.includes('did not generate the expected output') || lower.includes('content filter') || lower.includes('safety'))
    return i18next.t('errors:aiErrorContentFilter');
  if (lower.includes('timeout') || lower.includes('timed out'))
    return i18next.t('errors:aiErrorTimeout');
  if (lower.includes('rate limit') || lower.includes('429'))
    return i18next.t('errors:aiErrorRateLimit');
  if (lower.includes('402') || lower.includes('insufficient'))
    return i18next.t('errors:aiErrorInsufficientCredits');
  if (lower.includes('download') || lower.includes('decode') || lower.includes("couldn't load the audio"))
    return "The audio clip couldn't be loaded. Try generating it again.";
  return raw;
}
